/**
 * Portal Manta · TipoConsolPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { AmpliBadge } from '../../globals.js';
import { FonteModal } from '../charts/FonteModal.jsx';
import { TipPage } from './TipPage.jsx';
import { TipoRodoviaPageV2 } from '../lotes-tabs/TipoRodoviaPageV2.jsx';
import { EstruturasTecnicasPanel } from '../lotes-vis/EstruturasTecnicasPanel.jsx';

const TipoConsolPage = memo(function TipoConsolPage_Inner({lote}){
  const [estrModal, setEstrModal] = useState(null);
  return(<div style={{flex:1,overflow:'auto'}}>
    {estrModal && <FonteModal {...estrModal} onClose={()=>setEstrModal(null)}/>}
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#1E2A4A,#2D3F6B)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.9)',letterSpacing:'.1em',textTransform:'uppercase',position:'sticky',top:0,zIndex:2}}>
      A · TIPOLOGIAS (obras de ampliação) <AmpliBadge/>
    </div>
    <TipPage lote={lote}/>
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#1E2A4A,#2D3F6B)',borderTop:'1px solid rgba(255,255,255,.05)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.9)',letterSpacing:'.1em',textTransform:'uppercase'}}>
      B · TIPOLOGIA × RODOVIA (3 blocos)
    </div>
    <TipoRodoviaPageV2 lote={lote}/>
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#5D3A1A,#8B4A2D)',borderTop:'1px solid rgba(255,255,255,.05)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.95)',letterSpacing:'.1em',textTransform:'uppercase'}}>
      C · ESTRUTURAS TÉCNICAS — pavimento · OAE · passarela · MEF vs Manta
    </div>
    <EstruturasTecnicasPanel lote={lote} onFonte={setEstrModal}/>
  </div>);
});

export { TipoConsolPage };
export default TipoConsolPage;
